// components/Hero.js
import React from 'react';
import Button from './Button';
import Image from '../images/solar-energy.webp';

const Hero = () => {
  return (
    <div className="relative bg-gray-100 pt-24 pb-16 md:pt-32 md:pb-24">
      <div className="absolute inset-0 bg-cover bg-center opacity-20 z-0" 
           style={{ backgroundImage: "url('/api/placeholder/1920/1080')" }}></div>
      <div className="container mx-auto px-4 relative z-10">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
              Powering a Sustainable Future with Solar Energy
            </h1>
            <p className="text-lg text-gray-600 mb-8">
              Kaat Engineering provides premium solar installation services for residential, 
              commercial, and off-grid systems. Harness the power of the sun with our expert solutions.
            </p>
            <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
              <Button text="Our Services" onClick={() => {}} />
              <Button text="Get a Free Quote" onClick={() => {}} secondary={true} />
            </div>
          </div>
          <div className="hidden md:block">
            <img 
              src={Image} 
              alt="Solar Panel Installation" 
              className="rounded-lg shadow-xl"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
